import Vuex, { GetterTree, ActionTree, MutationTree, Action } from 'vuex';

interface ICustomerList {
    [key: string]: any;
    loading: boolean;
    infos: Array<{ [key: string]: any }>;
}

export interface IState {
    globalSearchObj: { [key: string]: any };
    globalSearchList: { [key: string]: any };
}

export const state: IState = {
    globalSearchObj: {
        time: new Date().getTime(),
        searchKey: ''
    },
    globalSearchList: {
        loading: false,
        infos: {}
    }
};

// tslint:disable-next-line:ban-types
export const getters: GetterTree<IState, Function> = {
    globalSearchObj: (myState: IState) => myState.globalSearchObj,
    globalSearchList: (myState: IState) => myState.globalSearchList
};
